import React from "react";

import { isEmptyObject } from "_helpers";

import { Button, Form, Space } from "antd";

export const CommonActionsCell = ({ 
    rec,
    editIsPending,
    tableData,
    onCancelRow,
    setEditModeKey,
    setValues
 }) => {
    const form = Form.useFormInstance();

    const handleEditRow = ( ) => {
        form.setFieldsValue({ ...rec });
        setEditModeKey(rec.key);
    }

    const handleCancelRow = ( ) => {
        form.resetFields();
        onCancelRow();
    }

    const handleSubmitRow = async ( method ) => {
        const values = {
            ...rec,
            ...form.getFieldsValue()
        };
        
        const key = values.key;
        if( key === 'new' ) method = 'add';

        if( ["add", "edit"].includes(method) ){
            try{
                await form.validateFields();
            } catch(err){
                console.log(err);
                return ;
            }
        }

        if( ["edit", "delete"].includes(method) ){
            const find = tableData.find(d => d['key'] === key)
            if( find ){
                setValues(values, method);
            }
        } else if( method === 'add' ){
            setValues(values, method);
        }
        handleCancelRow();
    }

    return(
        <Space>
            {
                !editIsPending
                ?
                    <>
                        <Button
                            type="primary"
                            onClick={handleEditRow}
                        >
                            Editer
                        </Button>
                        <Button 
                            type="primary"
                            danger
                            onClick={() => handleSubmitRow('delete')}
                        >
                            Supprimer
                        </Button>
                    </>
                :
                    <>
                        <Button
                            color="green"
                            variant="solid"
                            onClick={() => handleSubmitRow('edit')}
                        >
                            Sauver
                        </Button>
                        <Button
                            color="orange"
                            variant="solid"
                            onClick={handleCancelRow}
                        >
                            Annuler
                        </Button>
                    </>
            }
        </Space>
    );
}